module.exports = __webpack_public_path__ + "static/solution6-bcde58a31dc2254137c5d94deeed24d9.png";